/* ==============================================
   CRO Urgency Timer — Charu Perfumery House
   Managed via CLI. Do NOT edit in Shopify admin.
   ============================================== */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initTimer(el) {
    var endStr = el.dataset.end;
    if (!endStr) return;
    var endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;

    var hEl = el.querySelector('[data-ut-h]');
    var mEl = el.querySelector('[data-ut-m]');
    var sEl = el.querySelector('[data-ut-s]');

    function tick() {
      var diff = endTime - Date.now();
      if (diff <= 0) {
        el.classList.add('urgency-timer-row--expired');
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('.urgency-timer-row').forEach(initTimer);
})();
